module.exports = __webpack_public_path__ + "img/1.fb5a6367.png";